module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 228-1.c0f60258.svg";